import styles from '../../styles/Dictionary.module.css';
import React, { useRef, useCallback, useState, useEffect, memo, useMemo } from 'react';
import classnames from 'classnames';
import { dictionaryObjTypes, InferenceResult } from '../../types/DictionaryTypes';

interface ResultWordTypes {
    idx: number;
    word: string;
    wordInfo: InferenceResult;
    dictionaryObj: dictionaryObjTypes;
    useageIndex: number[];
    setUseageIndex: (i: number[]) => void;
}
const areEqual = (prevProps: ResultWordTypes, nextProps: ResultWordTypes) => {
  return !prevProps.useageIndex.includes(prevProps.idx) &&
            !nextProps.useageIndex.includes(nextProps.idx) &&
            prevProps.wordInfo.dictSeq === nextProps.wordInfo.dictSeq;
};
const ResultWord = memo(({ idx, word, wordInfo, dictionaryObj, useageIndex, setUseageIndex }: ResultWordTypes) => {
  const currentDl = useRef<HTMLDListElement>(null);
  const [onSelected, setSelected] = useState<boolean>(false);
  const { dictSeq, usageWords } = wordInfo;
  // let wordMean = !wordInfo.namedEntityType ? dictionaryObj[dictSeq] : {_id: -1, spell: '고유 명사', meaning: { meaning: wordInfo.namedEntityType }, usages: []};
  const wordMean = dictionaryObj[dictSeq];
  const meaning = wordMean?.meaning;
  const idxList = useMemo(() => usageWords ? usageWords : [idx], [idx, usageWords]);
  const spell = wordMean?.usages && wordInfo?.usageIndex !== undefined ? wordMean.usages[wordInfo.usageIndex].text : wordMean?.spell;
  const onSelectedWord = useCallback(() => {
    const dd = currentDl?.current?.querySelector('dd');
    const ddWidth: number = dd?.clientWidth ? dd.clientWidth + 10 : 10;
    const offset: number = currentDl.current?.offsetLeft ? currentDl.current.offsetLeft + ddWidth : ddWidth;
    if (window.innerWidth < offset) {
      currentDl.current?.querySelector('dd')?.classList.add(styles.right);
    }
    if (currentDl.current && ddWidth / 2 > currentDl.current?.offsetLeft) {
      currentDl.current?.querySelector('dd')?.classList.add(styles.left);
    }
    if (idxList.length > 1) setUseageIndex(idxList);
    if (idxList.length === 1) setSelected(true);
  }, [setUseageIndex, idxList]);
  const onUnSelectedWord = useCallback(() => {
    currentDl.current?.querySelector(styles.right)?.classList.remove(styles.right);
    currentDl.current?.querySelector(styles.left)?.classList.remove(styles.left);
    currentDl.current?.querySelector('.' + styles.show_dd)?.classList.remove(styles.show_dd);
    if (idxList.length > 1) setUseageIndex([]);
    if (idxList.length === 1) setSelected(false);
  }, [idxList, setUseageIndex]);
    // PC mouseover event
  const onMouseOver = useCallback(() => {
    if (window.innerWidth >= 1025) {
      onSelectedWord();
    }
  }, [onSelectedWord]);
  const onMouseLeave = useCallback(() => {
    if (window.innerWidth >= 1025) {
      onUnSelectedWord();
    }
  }, [onUnSelectedWord]);
    // Mobile click event
  const onClick = useCallback((e: React.MouseEvent) => {
    if (window.innerWidth < 1025) {
      currentDl.current?.querySelector('dd')?.classList.remove(styles.right);
      currentDl.current?.querySelector('dd')?.classList.remove(styles.left);
      document.querySelector('.' + styles.show_dd)?.classList.remove(styles.show_dd);
      e.currentTarget.querySelector('dt')?.classList.add(styles.show_dd);
      onSelectedWord();
    }
  }, [onSelectedWord]);

  useEffect(() => {
    const pageClickEvent = (e: Event) => {
      const target = e.target as Node;
      if (window.innerWidth < 1025 &&
                target instanceof HTMLElement &&
                currentDl.current?.classList.contains(styles.is_active) &&
                !currentDl.current?.contains(target)) {
        onUnSelectedWord();
      }
    };
    window.addEventListener('mouseup', pageClickEvent);
    window.addEventListener('touchend', pageClickEvent);
    return () => {
      window.removeEventListener('mouseup', pageClickEvent);
      window.removeEventListener('touchend', pageClickEvent);
    };
  }, [onUnSelectedWord]);
  const properNounText = wordInfo.namedEntityType ? '고유 명사' : '';
  return (
    <>
      <dl
        ref={currentDl}
        className={onSelected || useageIndex.includes(idx) ? classnames(styles.wordInfo, styles.is_active) : styles.wordInfo}
        data-space-on={useageIndex.includes(idx + 1) ? true : false}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      >
        <dt>{word}</dt>
        <dd>
          <span className={styles.propernoun}>{properNounText}</span>
          <strong>{spell}</strong>
          <i>{meaning?.premise}</i>
          <em>{meaning?.meaning}</em>
          <span>{meaning?.explain}</span>
          <button onClick={(e) => {e.stopPropagation(); onUnSelectedWord();}}>close</button>
        </dd>
      </dl>
    </>
  );
}, areEqual);
export default ResultWord;
